import { Injectable } from '@angular/core';
import { TableFilter } from 'app/component-library/table/filtering/table-filter';
import { TableAction } from 'app/component-library/table/table-action';
import { TableConfig } from 'app/component-library/table/table-config';
import { TableParameters } from 'app/component-library/table/table-parameters';
import { LazyLoadEvent } from 'primeng/api';
import { TableActions } from '../enums/table-actions';
import { UpdateState, UpdateStateItem } from '../update-state-item';
import { RecordCountConfigParams, defaultEditedItemStyleName } from './table-helper';

@Injectable({
  providedIn: 'root',
})
export class TableConfigHelperService {
  constructor() { }

  public createDeleteTableAction(title: string, visible: boolean): TableAction {
    const tableAction = new TableAction();
    tableAction.icon = 'trash';
    tableAction.enable = false;
    tableAction.actionId = TableActions.Delete;
    tableAction.visible = visible;
    tableAction.title = title;
    return tableAction;
  };

  public updateDeleteAction(config: TableConfig, visible: boolean, enable: boolean = undefined): void {
    if (!config) { return; }
    const deleteAction = config.actions.find(x => x.actionId === TableActions.Delete);

    if (!deleteAction) { return; }

    deleteAction.visible = visible;
    if (enable !== undefined) {
      deleteAction.enable = enable;
    }
  };

  public getRowStyleClass(rowData: UpdateStateItem): string {
    return (rowData.state === UpdateState.Added || rowData.state === UpdateState.Modified) && defaultEditedItemStyleName;
  }

  public modifyConfig = (config: TableConfig, params: object): void => {
    Object.keys(params).forEach(k => config[k] = params[k]);
  };

  public createRecordCountConfigParams(totalRecords: number, hasFilters: boolean): RecordCountConfigParams {
    if (totalRecords === 0 && !hasFilters) {
      return {
        showFilters: false,
        enableFiltering: false,
        totalRecords,
      };
    } else {
      return {
        enableFiltering: true,
        totalRecords,
      };
    }
  }

  public createTableParameters(tableState: LazyLoadEvent, selectedItemId: string, filters: TableFilter[]): TableParameters {
    const params = new TableParameters();
    params.selectedItemId = selectedItemId;
    params.filters = filters;
    params.sortField = tableState.sortField;
    params.sortOrder = tableState.sortOrder;
    params.skip = tableState.first;
    params.take = tableState.rows;
    return params;
  }
}
